import { render, staticRenderFns } from "./RegulationList.vue?vue&type=template&id=60468791&scoped=true&"
import script from "./RegulationList.vue?vue&type=script&lang=js&"
export * from "./RegulationList.vue?vue&type=script&lang=js&"
import style0 from "./RegulationList.vue?vue&type=style&index=0&id=60468791&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60468791",
  null
  
)

export default component.exports